// extracted by mini-css-extract-plugin
module.exports = {"slider":"_2e0b_"};